window.slate = window.slate || {};
window.theme = window.theme || {};

window.hasThumbSliderEnabled = false;
window.productGalleryUpdate = true;
window.t_o;
window.restrictGalleryUpdate = () => {
  window.productGalleryUpdate = false;
  clearTimeout(window.t_o);
  window.t_o = setTimeout(() => {
    window.productGalleryUpdate = true;
  }, 500);
};

window.initProductGallery = () => {
  const galleries = $("[data-color-gallery]");
  const prevArrow =
    '<button class="slick-arrow slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg></button>';
  const nextArrow =
    '<button class="slick-arrow slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg></button>';

  if (galleries.length > 0) {
    galleries.each(function () {
      const productGallery = $(this).find(".js-product__gallery");
      const thumbnailGallery = $(this).find(".js-product__thumbnail-gallery");

      $(productGallery).slick({
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        slidesToScroll: 1,
        rows: 0,
        infinite: false,
        arrows: false,
        dots: true,
        asNavFor: window.hasThumbSliderEnabled ? $(thumbnailGallery) : null,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              arrows: true,
              draggable: false,
              swipe: false,
              touchMove: false,
              accessibility: false,
            },
          },
        ],
      });

      if (window.hasThumbSliderEnabled) {
        $(thumbnailGallery).slick({
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          arrows: false,
          slidesToScroll: 1,
          rows: 0,
          infinite: false,
          slidesToShow: 5,
          dots: false,
          focusOnSelect: true,
          asNavFor: $(productGallery),
        });

        $(thumbnailGallery).on("afterChange", function (ev, slick, current) {
          const currentSlide = slick.$slides.get(current);
          $("[data-product-single-thumbnail]", $(thumbnailGallery)).removeClass(
            "slick-currentt"
          );
          $(currentSlide).addClass("slick-currentt");

          $(".slick-arrow-custom").removeClass("slick-disabled");
          if (current === 0) {
            $(".slick-arrow-custom.slick-prev").addClass("slick-disabled");
          } else if (current === slick.$slides.length - 1) {
            $(".slick-arrow-custom.slick-next").addClass("slick-disabled");
          }

          $(ev.target).data("current-slide", current);
        });

        $(thumbnailGallery).on("wheel scroll", function (e) {
          e.preventDefault();
          let deltaY = e.originalEvent.deltaY;
          let deltaX = e.originalEvent.deltaX;
          let slider = $(this).slick("getSlick");
          let currentSlickIndex = slider.currentSlide;
          if (
            // check when you scroll up
            ((deltaY < 0 || deltaX < 0) && currentSlickIndex == 0) ||
            // check when you scroll down
            ((deltaY > 0 || deltaX > 0) &&
              currentSlickIndex == slider.slideCount)
          ) {
            return;
          }
          if (deltaY < 0 || deltaX < 0) {
            $(this).slick("slickPrev");
          } else {
            $(this).slick("slickNext");
          }
        });
      } else {
        $("[data-product-single-thumbnail]", thumbnailGallery).on(
          "click",
          function (e) {
            if (window.productGalleryUpdate) {
              let mediaId = $(this).data("id");
              // logtest("mediaId", mediaId);
              $("[data-product-single-thumbnail]").removeClass("active-slide");
              $(this).addClass("active-slide");

              var currentScrl = thumbnailGallery.scrollLeft();
              var leftPos = $(this).position().left;
              e.preventDefault();
              // enable to smooth scroll to active slide
              thumbnailGallery.animate(
                {
                  scrollLeft: currentScrl + leftPos - 25,
                },
                200
              );

              let mainSlide = $(productGallery).find(
                `[data-product-slide]:not(.slick-cloned)[data-id="${mediaId}"]`
              );
              let slideno = $(mainSlide).data("slick-index");
              $(productGallery).slick("slickGoTo", slideno);
              window.restrictGalleryUpdate();
            }
          }
        );

        $(productGallery).on("afterChange", function (ev, slick, current) {
          if (window.productGalleryUpdate) {
            let currentSlideDom = $(slick.$slides.get(current));
            let mediaId = currentSlideDom.data("id");
            let scrollToElm = $(`[data-id="${mediaId}"]`, thumbnailGallery);
            // enable to move focus to active slide
            scrollToElm.click();

            // experimental :: do not enable without understanding code.
            // window.restrictGalleryUpdate();
          }
        });

        $(thumbnailGallery).on("DOMMouseScroll mousewheel", function (e) {
          if (e.originalEvent.deltaX === 0) {
            e.stopPropagation();
            e.preventDefault();
            let amount = 60;
            let position = $(this).scrollLeft();
            let deltaY = e.originalEvent.deltaY;
            if (Math.abs(deltaY) >= 40) deltaY /= 40;
            let direction = 0;
            if (deltaY < 0) {
              direction = 1;
            }
            position += direction > 0 ? -amount : amount;
            $(this).scrollLeft(position);
          }
        });

        $(document).on("keydown", function (e) {
          if (!e.key.includes("Arrow")) return;
          let isVisible = isInViewport($(thumbnailGallery));
          if (!isVisible) return;
          let direction = e.key === "ArrowUp" || e.key === "ArrowLeft" ? 0 : 1;
          let thumbs = $("[data-product-single-thumbnail]");
          let arr = [...thumbs].filter(
            (thumb) => !$(thumb).hasClass("is-filtered")
          );
          if (direction === 0) {
            arr.map((item, i) => {
              if ($(item).hasClass("active-slide") && i > 0) {
                $(arr[i - 1]).click();
                e.stopPropagation();
                e.preventDefault();
              }
            });
          } else {
            arr.map((item, i) => {
              if ($(item).hasClass("active-slide") && i < arr.length - 1) {
                $(arr[i + 1]).click();
                e.stopPropagation();
                e.preventDefault();
              }
            });
          }
        });
      }
    });
  }
};
/***************** GLOBAL *****************/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === "undefined"
        ? ""
        : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === "undefined"
        ? ""
        : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:section:reorder", this._onReorder.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === "function") {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === "function") {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === "function") {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === "function") {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === "function") {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === "function") {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = "${{amount}}";

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ",");
      decimal = slate.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    var params = {
      $container: this.$container,
      product: options.product,
      singleOptionSelector: options.singleOptionSelector,
      originalSelectorId: options.originalSelectorId,
      currentVariant: this.currentVariant,
    };

    this.swatches = new slate.Swatches(params);

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      // variant specific dropdown

      let material = metaData[variant.id];
      let input = document.querySelector('input[name="properties[__vnotice]"]');
      if (material) {
        let metaText = "";
        let joinedText = "";
        material.forEach((el) => {
          if (el !== "") {
            metaText += `<p class="variant-note">${el}</p>`;
            joinedText += el + " ";
          }
        });
        document.querySelector(".variant-note-wrapper").innerHTML = metaText;
        if (input) {
          if (joinedText.trim() !== "") {
            input.value = joinedText.trim();
          } else {
            input.value = "";
          }
        }
      } else {
        document.querySelector(".variant-note-wrapper").innerHTML = "";
        if (input) {
          input.value = "";
        }
      }

      if (
        document.getElementById("logo-proof")?.classList.contains("visible")
      ) {
        if (document.getElementById("logo-proof").checked) {
          document.getElementById("customily-cart-btn").disabled = false;
        } else {
          document.getElementById("customily-cart-btn").disabled = true;
        }
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      // this._filterThumbnails(variant);
      // this._updatePrice(variant);
      this._filterThumbnailsNew(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
      //check if recharge product
      if ($(".custom-recharge-widget").length > 0) {
        $(".custom-otp-price").html($(".rc_widget__price--onetime").html());
        $(".custom-subsave-price").html($(".rc_widget__price--subsave").html());
      }

      setTimeout(() => {
        updateDiscountQuantityPrice();
      }, 300);
    },

    _filterThumbnails: function (variant) {
      if (
        variant.featured_image != null &&
        variant.featured_image.alt != null
      ) {
        $("[data-thumbnail-color]").hide();
        $("[data-slide-color]").hide();

        let selected_color = variant.featured_image.alt;
        let thumbnail_selector = `[data-thumbnail-color=${selected_color}]`;
        let slide_selector = `[data-slide-color=${selected_color}]`;

        $(thumbnail_selector).show();
        $(slide_selector).show();
      } else {
        $("[data-thumbnail-color]").show();
        $("[data-slide-color]").show();
      }
    },

    _filterThumbnailsNew: function (variant) {
      window._filterAllMedia(variant, "_filterThumbnailsNew");
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
  });

  return Variants;
})();

/**
 * Swatches Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the swatches inputs in any `cart/add` forms that may
 * exist.
 *
 * @namespace swatches
 */

slate.Swatches = (function () {
  var selectors = {
    swatches: "[data-swatch]",
    swatchOptions: "[data-swatch-option]",
  };

  /**
   * Swatches constructor
   *
   * @param {object} options - Settings from `variants.js`
   */
  function Swatches(params) {
    this.$container = params.$container;
    this.product = params.product;
    this.currentVariant = params.currentVariant;
    this.singleOptionSelector = params.singleOptionSelector;
    this.originalSelectorId = params.originalSelectorId;
    this.variants = this.product.variants;
    this.options = this.product.options;
    this.swatches = $(selectors.swatches);
    this.swatchOptions = this.swatches.find(selectors.swatchOptions);
    this.colorOptionIndex = this.getOptionIndex("color");

    this.hideSwatchesSelects();
    this.defineAvailableColors();
    this.updateVariantMax(this.currentVariant);

    let self = this;
    this.showAvailableOptions(this, this.swatches);

    $(this.swatchOptions, this.$container).on("change", function () {
      let evt = $(this);
      self.switchSwatches.bind(self)(evt);
    });

    $(`[data-swatch="Color"]`)
      .find(".header > span")
      .text(this.currentVariant.options[self.colorOptionIndex]);

    $(this.swatchOptions, this.$container)
      .parent()
      .change(
        function () {
          let $option = $(this).find(selectors.swatchOptions);

          if ($option.data("swatch-option") == self.colorOptionIndex) {
            let $swatchHolder = $option.closest(selectors.swatches);
            $swatchHolder.find(".header > span").text($option.val());
          }
        },
        function () {
          let $option = $(this).find(selectors.swatchOptions);

          if ($option.data("swatch-option") == self.colorOptionIndex) {
            let $swatchHolder = $option.closest(selectors.swatches);
            $swatchHolder.find(".header > span").text($option.val());
          }
        }
      );
  }

  Swatches.prototype = $.extend({}, Swatches.prototype, {
    hideSwatchesSelects: function () {
      let self = this;

      this.swatches.each(function () {
        let $swatch = $(this);
        $(self.singleOptionSelector)
          .eq(self.getOptionIndex($swatch.data("swatch")))
          .parent()
          .hide();
      });
    },

    /**
     * Show only av
     *
     * @param {object} variant - Currently selected variant
     */
    defineAvailableColors: function () {
      let self = this;

      if (this.colorOptionIndex >= 0) {
        $.each(this.variants, function (i, variant) {
          if (variant.available) {
            let $option = self.swatchOptions.filter(
              "#swatch-" +
                self.colorOptionIndex +
                "-" +
                variant.options[self.colorOptionIndex]
                  .toLowerCase()
                  .replace("/", "-")
            );
            self.makeSwatchOptionAvailable($option);
          }
        });
      }
    },

    makeSwatchOptionAvailable: function ($option) {
      $option.parent().addClass("available").removeClass("soldout");

      return $option;
    },

    makeSwatchOptionUnavailable: function ($option) {
      $option
        .prop("checked", true)
        .parent()
        .addClass("soldout")
        .removeClass("available");

      return $option;
    },

    getOptionIndex: function (optionName) {
      return this.options
        .map((v) => v.toLowerCase())
        .indexOf(optionName.toLowerCase());
    },

    getVariantLabels: function (variant) {
      const badgesLists = document.querySelectorAll(".product-badges");
      if (!badgesLists) {
        return;
      }

      badgesLists.forEach((badgesList) => {
        const variantId = badgesList.getAttribute("data-variant-id");

        badgesList.classList.add("hide");
        if (variantId == variant.id) {
          badgesList.classList.remove("hide");
        }
      });
    },

    updateVariantMax: function (variant) {
      const variantQtyMax = jQuery("[data-product-select]")
        .find("[data-variant-qty]:selected")
        .attr("data-variant-qty");
      const variantPolicy = jQuery("[data-product-select]")
        .find("[data-variant-policy]:selected")
        .attr("data-variant-policy");
      const productQty = document.querySelector(".product-qty-input");
      const productQtyVal = productQty.value;

      if (variantPolicy == "continue") {
        jQuery(productQty).removeAttr("max");
      } else {
        jQuery(productQty).attr("max", variantQtyMax);
        if (productQtyVal > variantQtyMax) {
          jQuery(productQty).attr("value", variantQtyMax);
          jQuery(productQty).val(variantQtyMax);
        }
      }
    },

    switchSwatches: function ($option) {
      let self = this;
      let swatchIndex = $option.data("swatch-option");
      let $optionSelector = $(this.singleOptionSelector).eq(swatchIndex);
      let optionVal = $option.val();

      if ($optionSelector.val() !== optionVal) {
        let $otherSwatches = this.swatches.filter(function (index) {
          return $(self.swatches[index]).data("option-index") != swatchIndex;
        });
        if (swatchIndex != this.colorOptionIndex) {
          let $swatchesWithoutColor = this.swatches.filter(function (index) {
            return (
              $(self.swatches[index]).data("option-index") !=
              self.colorOptionIndex
            );
          });
          $otherSwatches = $otherSwatches.filter(
            (value) => !$swatchesWithoutColor.has(value)
          );
        }
        // if ($otherSwatches.length > 0) {
        //   this.showAvailableOptions(self, $otherSwatches, optionVal, 'switch');
        // }
        $optionSelector.val(optionVal);
      }

      $(this.singleOptionSelector).first().trigger("change");
      this.currentVariant = self.variants.filter(function (v) {
        return v.id == $(self.originalSelectorId).val();
      })[0];
    },

    showAvailableOptions: function (
      self,
      $swatches,
      optionVal = "",
      type = "load"
    ) {
      let hasChecked = false;
      let allSoldOut = true;
      let notInventory = true;
      let form = $swatches.closest("form");

      $.each(self.variants, function (i, variant) {
        if (variant.available) {
          allSoldOut = false;
        }
        if (variant.inventory_management == null) {
          notInventory = false;
        }
      });
      if (notInventory) {
        self.makeSwatchOptionUnavailable(
          $swatches.find(selectors.swatchOptions)
        );
      }
      if (!allSoldOut || type != "load" || !notInventory) {
        $.each(self.variants, function (i, variant) {
          if (self.colorOptionIndex >= 0) {
            if (
              (variant.options[self.colorOptionIndex] == optionVal ||
                (optionVal.length === 0 &&
                  variant.options[0] == self.currentVariant.options[0])) &&
              variant.available
            ) {
              $.each($swatches, function (i, swatch) {
                let $swatch = $(swatch);
                let currentSwatchIndex = $swatch.data("option-index");
                let $optionSelector = $(self.singleOptionSelector).eq(
                  currentSwatchIndex
                );
                let $option = $(
                  '[data-value="' + variant.options[currentSwatchIndex] + '"]'
                )
                  .find(selectors.swatchOptions)
                  .first();

                self.makeSwatchOptionAvailable($option);
                if (type == "load") {
                  if (
                    self.currentVariant.options[currentSwatchIndex] ==
                    variant.options[currentSwatchIndex]
                  ) {
                    $option.prop("checked", true);
                    $optionSelector.val(variant.options[currentSwatchIndex]);
                  }
                } else {
                  if (self.currentVariant) {
                    if (
                      self.currentVariant.options[currentSwatchIndex] ==
                      variant.options[currentSwatchIndex]
                    ) {
                      $option.prop("checked", true);
                      $optionSelector.val(variant.options[currentSwatchIndex]);
                    } else if (!hasChecked) {
                      $option.prop("checked", true);
                      $optionSelector.val(variant.options[currentSwatchIndex]);
                    }
                  } else if (!hasChecked) {
                    $option.prop("checked", true);
                    $optionSelector.val(variant.options[currentSwatchIndex]);
                  }
                  hasChecked = true;
                }
              });
            } else {
              $.each($swatches, function (i, swatch) {
                let $swatch = $(swatch);
                let currentSwatchIndex = $swatch.data("option-index");
                let $option = $(
                  '[data-value="' + variant.options[currentSwatchIndex] + '"]'
                )
                  .find(selectors.swatchOptions)
                  .first();

                if (variant.available) {
                  self.makeSwatchOptionAvailable($option);
                }
              });
            }
          } else {
            $.each($swatches, function (i, swatch) {
              let $swatch = $(swatch);
              let currentSwatchIndex = $swatch.data("option-index");
              let $optionSelector = $(self.singleOptionSelector).eq(
                currentSwatchIndex
              );
              let $option = $(
                '[data-value="' + variant.options[currentSwatchIndex] + '"]'
              )
                .find(selectors.swatchOptions)
                .first();

              self.makeSwatchOptionAvailable($option);
              if (type == "load") {
                if (
                  self.currentVariant.options[currentSwatchIndex] ==
                  variant.options[currentSwatchIndex]
                ) {
                  $option.prop("checked", true);
                  $optionSelector.val(variant.options[currentSwatchIndex]);
                }
              } else {
                if (self.currentVariant) {
                  if (
                    self.currentVariant.options[currentSwatchIndex] ==
                    variant.options[currentSwatchIndex]
                  ) {
                    $option.prop("checked", true);
                    $optionSelector.val(variant.options[currentSwatchIndex]);
                  } else if (!hasChecked) {
                    $option.prop("checked", true);
                    $optionSelector.val(variant.options[currentSwatchIndex]);
                  }
                } else if (!hasChecked) {
                  $option.prop("checked", true);
                  $optionSelector.val(variant.options[currentSwatchIndex]);
                }
                hasChecked = true;
              }
            });
          }
        });
      } else {
        for (let i = 0; i < 3; i++) {
          if (self.currentVariant.options[i]) {
            form
              .find(`[data-value="${self.currentVariant.options[i]}"]`)
              .find("input")
              .prop("checked", true);
          }
        }
      }
    },
  });

  return Swatches;
})();

/***************** TEMPLATES *****************/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $("#AddressNewForm");

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      "AddressCountryNew",
      "AddressProvinceNew",
      {
        hideElement: "AddressProvinceContainerNew",
      }
    );
  }

  // Initialize each edit form's country/province selector
  $(".address-country-option").each(function () {
    var formId = $(this).data("form-id");
    var countrySelector = "AddressCountry_" + formId;
    var provinceSelector = "AddressProvince_" + formId;
    var containerSelector = "AddressProvinceContainer_" + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $(".address-new-toggle").on("click", function () {
    $newAddressForm.toggleClass("hide");
    $(".address-list__item").toggleClass("hide");
    $(".btn--new-address").toggleClass("hide");
    $(".account-page__greeting-title").toggleClass("hide");
    $(".js-address-mobile-link").toggleClass("hide");
    $(".js-address-mobile-link--alt").toggleClass("hide");
    $(".pagination").toggleClass("hide");
    $("html, body").animate({ scrollTop: 0 }, 500);
  });

  $(".address-edit-toggle").on("click", function (e) {
    e.preventDefault();
    var formId = $(this).data("form-id");
    $("#EditAddress_" + formId).toggleClass("hide");
    $(".address-list__item").toggleClass("hide");
    $(".address-new-toggle").toggleClass("hide");
    $(".account-page__greeting-title").toggleClass("hide");
    $(".js-address-mobile-link").toggleClass("hide");
    $(".js-address-mobile-link--alt").toggleClass("hide");
    $(".pagination").toggleClass("hide");
    $("html, body").animate({ scrollTop: 0 }, 500);
  });

  $(".js-address-mobile-link--alt").on("click", function (e) {
    e.preventDefault();
    $newAddressForm.addClass("hide");
    $(".js-edit-form").each(function () {
      $(this).addClass("hide");
    });
    $(".address-list__item").removeClass("hide");
    $(".btn--new-address").removeClass("hide");
    $(".account-page__greeting-title").removeClass("hide");
    $(".js-address-mobile-link").removeClass("hide");
    $(".address-new-toggle").removeClass("hide");
    $(".pagination").removeClass("hide");
    $(this).addClass("hide");
  });

  $(".address-delete").on("click", function () {
    var $el = $(this);
    var formId = $el.data("form-id");
    var confirmMessage = $el.data("confirm-message");
    if (
      confirm(confirmMessage || "Are you sure you wish to delete this address?")
    ) {
      Shopify.postLink("/account/addresses/" + formId, {
        parameters: { _method: "delete" },
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: "#RecoverPassword",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productSlider: "[data-product-slider]",
    productThumbnails: "[data-product-thumbnails]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    productThumbs: "[data-product-single-thumbnail]",
    singleOptionSelector: "[data-single-option-selector]",
    productBtnWrap: "[data-product-btn-wrap]",
    rechargeWidget: "[data-recharge-widget]",
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    var self = this;
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr("data-section-id");
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = ".product";
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.currentVariant = this.variants.currentVariant;
    self.updateProductSlider.bind(self)();

    this.$container.on(
      "variantChange" + this.namespace,
      this.updateProductSlider.bind(this)
    );
    this.$container.on(
      "variantChange" + this.namespace,
      this.updateQuantityMax.bind(this)
    );
    this.$container.on(
      "variantChange" + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      "variantPriceChange" + this.namespace,
      this.updateProductPrices.bind(this)
    );
    this.$container.on(
      "variantChange" + this.namespace,
      this.updateSku.bind(this)
    );

    updateDiscountTable(this.currentVariant);
    this.$container.on("variantChange" + this.namespace, (evt) =>
      updateDiscountTable(evt.variant)
    );
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;
      let isComingSoon = false;
      try {
        isComingSoon = this.productSingleObject.tags.includes("coming_soon");
        if (isComingSoon) variant.available = false;
      } catch {}
     console.log({ variant, isComingSoon, product: this.productSingleObject, theme });
      if (variant && !isComingSoon) {
        $(selectors.priceWrapper, this.$container).removeClass("hide");
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.productBtnWrap, this.$container).addClass("btn-disabled");
        $(selectors.addToCartText, this.$container).html(
          isComingSoon ? theme.strings.comingSoon : theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).removeClass("hide");
        $(selectors.rechargeWidget, this.$container).removeClass("hide");
        return;
      }

      if (variant.available && !isComingSoon) {
        $(selectors.addToCart, this.$container).prop("disabled", false);
        $(selectors.productBtnWrap, this.$container).removeClass(
          "btn-disabled"
        );
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        );
        $(selectors.rechargeWidget, this.$container).removeClass("hide");
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.productBtnWrap, this.$container).addClass("btn-disabled");
        $(selectors.addToCartText, this.$container).html(
          isComingSoon ? theme.strings.comingSoon : theme.strings.soldOut
        );
        //$(selectors.rechargeWidget, this.$container).addClass("hide")
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass("hide");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
      }
    },

    /**
     * Updates the DOM
     */
    updateQuantityMax: function (evt) {
      var variant = evt.variant;

      const quantityWrap = jQuery(".product-btn__wrap .jcf-number");
      const quantityBtnInc = jQuery(quantityWrap).find(".jcf-btn-inc");
      const quantityBtnDec = jQuery(quantityWrap).find(".jcf-btn-dec");
      const quantityInput = jQuery("#Quantity");
      const quantityInputValue = quantityInput.val();
      const quantityInputMax = quantityInput.attr("max");

      let variantMaxQty = variant.inventory_quantity;

      if (variantMaxQty == 1) {
        $(quantityInput).attr({ max: variantMaxQty });
        quantityInput.val("1");
        quantityBtnInc.addClass("jcf-disabled");
        quantityBtnDec.addClass("jcf-disabled");

        jcf.destroyAll();
        jcf.setOptions("Select", {
          wrapNative: false,
        });
        jcf.replaceAll();
      } else if (variantMaxQty > 1) {
        $(quantityInput).attr({ max: variantMaxQty });
        quantityBtnInc.removeClass("jcf-disabled");
        quantityInput.val("1");

        jcf.destroyAll();
        jcf.setOptions("Select", {
          wrapNative: false,
        });
        jcf.replaceAll();
      } else if (variant.inventory_policy == "continue") {
        quantityInput.removeAttr("max");
        quantityBtnInc.removeClass("jcf-disabled");
        jcf.destroyAll();
        jcf.setOptions("Select", {
          wrapNative: false,
        });
        jcf.replaceAll();
      }
    },

    updateSku: function (evt) {
      var variant = evt.variant;
      const skuWrap = jQuery(".js-product-sku");

      $(skuWrap).text(variant.sku);

      if ($(skuWrap).text()) {
        $(skuWrap).removeClass("hide");
      } else {
        $(skuWrap).addClass("hide");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      this.$featuredImage.attr("src", sizedImgUrl);
    },

    /**
     * Updates the DOM with the specified slides
     */
    updateProductSlider: function (evt) {
      // let variant = evt !== undefined ? evt.variant : this.currentVariant;
      // let colorOptionIndex = this.productSingleObject.options.map(v => v.toLowerCase()).indexOf('color');
      // let color = variant.options[colorOptionIndex];
      // let sliders = jQuery(`.product__thumbnail-gallery-item[data-color="${color}"]`);
      const $ = jQuery;

      const variant = evt !== undefined ? evt.variant : this.currentVariant;
      window._filterAllMedia(variant, "ini");
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },
  });

  return Product;
})();

(function () {
  const skuWrap = jQuery(".js-product-sku");

  if ($(skuWrap).text()) {
    $(skuWrap).removeClass("hide");
  } else {
    $(skuWrap).addClass("hide");
  }
})();
(function () {
  var sustainabilityGallery;
  ResponsiveHelper.addRange({
    "..767": {
      on: function () {
        sustainabilityGallery = new Swiper(".about-sustainability-gallery", {
          spaceBetween: 38,
          slidesPerView: "1.285",
          watchOverflow: true,
          loop: false,
          speed: 800,
          pagination: {
            el: ".swiper-slider",
            type: "progressbar",
          },
          breakpoints: {
            576: {
              spaceBetween: 38,
              slidesPerView: "2.285",
              pagination: {
                el: ".swiper-slider",
                type: "progressbar",
              },
            },
          },
        });
      },
      off: function () {
        if ($(".about-sustainability-gallery").length) sustainabilityGallery.destroy(true, true);
      },
    },
  });

  let aboutGallery = new Swiper(".about-gallery-js", {
    spaceBetween: 35,
    slidesPerView: "1.265",
    watchOverflow: true,
    loop: false,
    speed: 800,
    centeredSlides: false,
    initialSlide: 0,
    pagination: {
      el: ".swiper-slider",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      576: {
        spaceBetween: 35,
        slidesPerView: "2.285",
        centeredSlides: false,
        loop: false,
        initialSlide: 0,
        pagination: {
          el: ".swiper-slider",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      768: {
        slidesPerView: "1.57",
        spaceBetween: 70,
        centeredSlides: true,
        loop: true,
        initialSlide: 1,
        pagination: {
          el: ".swiper-slider",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      1024: {
        slidesPerView: "1.57",
        spaceBetween: 155,
        centeredSlides: true,
        loop: true,
        initialSlide: 1,
        pagination: {
          el: ".swiper-slider",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    },
  });

  const swiper = new Swiper(".about-gallery-journey-js", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    on: {
      slideChange: function () {
        updateActiveYear(swiper.activeIndex);
      }
    }
  });
  
  // Clickable Year Nav
  document.querySelectorAll('.year').forEach((el, index) => {
    el.addEventListener('click', () => {
      swiper.slideTo(index);
    });
  });
  
  // Helper Function to Update Active Class
  function updateActiveYear(index) {
    document.querySelectorAll('.year').forEach((el, i) => {
      el.classList.toggle('active', i === index);
    });
  }
  
})();
$(".collection-filter__list").each(function () {
  if (!$(this).children().length > 0) {
    $(this).parent().addClass("hide");
  }
});

setTimeout(() => {
  if ($(".filter-list__item").length === $(".filter-list__item.hide").length) {
    $(".collection__aside").remove();
    $(".collection__content").css("width", "100%");
  }
}, 100);

$(".filter-list__item").openClose({
  opener: ".js-collection-opener",
  slider: ".collection-filter__list",
  animSpeed: 400,
  effect: "slide",
});
(function () {
  var classList = $(".collection-filter__item");
  $(classList).each(function () {
    if ($(this).hasClass("active")) {
      $(this).siblings().addClass("hide");
      $(this).closest(".filter-list__item").addClass("active");
      $(".filter-list__item.active")
        .find(".collection-filter__list")
        .removeClass("js-slide-hidden");
      $(".filter-list__item.active")
        .closest(".collection__aside")
        .find(".clear-all")
        .removeClass("hide");
    }
  });
})();

$(".collection__open-close").openClose({
  opener: ".opener",
  slider: ".slide",
  animSpeed: 400,
  effect: "slide",
  hideOnClickOutside: true,
});

// set collection image height
function calculateHeight() {
  let imageHeight = $(
    ".collection__content--holder .featured-product__gallery"
  ).height();
  $(".collection-filters__image-holder").css("height", imageHeight);
}
calculateHeight();

$(window).resize(function () {
  calculateHeight();
});

// mobile filters
$(".filters-button").click(function () {
  $("body").addClass("mobile-filter-list");
});

$(".filter__heading .icon__close-search").click(function () {
  $("body").removeClass("mobile-filter-list");
});

$(".protected-password__link a").on("click", function () {
  $(".protected-password__login").removeClass("hide");
  $(".password-protected__main").addClass("hide");
});

(function () {
  $(".js-article-holder").masonry({
    itemSelector: ".js-article",
    columnWidth: ".grid-sizer",
    percentPosition: true,
    horizontalOrder: true,
  });
})();
(function () {
  new SmoothScroll({
    extraOffset: $(".section--header").height() || 0,
    anchorLinks: ".article__anchor-link",
    activeClasses: "parent",
    wheelBehavior: "ignore",
    animDuration: 800,
  });

  if ($(".template-article").length > 0) {
    const articleUrl = window.location.href.toString();

    function setLocation(curLoc) {
      try {
        history.pushState(null, null, articleUrl + "#" + curLoc);
        return;
      } catch (e) {}
      location.hash = articleUrl + "#" + curLoc;
    }

    if (
      articleUrl.includes("page=") &&
      !articleUrl.includes("comment-section")
    ) {
      setLocation("comment-section");
    }
  }
})();

/***************** BLOCKS *****************/
$(".sub-navigation__frame").parent().addClass("navigation__item--full");

$(".navigation__item").each(function () {
  var item = jQuery(this);
  var drop = item.find("ul");
  var link = item.find("a").eq(0);
  if (drop.length) {
    item.addClass("has-drop-down");
    if (link.length) link.addClass("has-drop-down-a");
  }
});

$("body").mobileNav({
  menuActiveClass: "search-active",
  menuOpener: ".js-search__opener",
  hideOnClickOutside: true,
  menuDrop: ".header__search",
});

$("body").mobileNav({
  hideOnClickOutside: true,
  menuActiveClass: "mobile-navigation--active",
  menuOpener: ".js-navigation-opener",
  menuDrop: ".mobile-navigation__wrap",
});

$(".mobile-navigation").slideAccordion({
  opener: ">.mobile-navigation__link, >.mobile-sub-navigation__link",
  slider: ">.mobile-sub-navigation, >.mobile-submenu",
  collapsible: true,
  animSpeed: 300,
  scrollToActiveItem: {
    enable: true,
    breakpoint: 1023,
    extraOffset: 0,
  },
});

$(window).scroll(function () {
  if ($(window).scrollTop() > 0) {
    $(".section--header").addClass("fixed-position");
  } else {
    $(".section--header").removeClass("fixed-position");
  }
});

$(document).ready(function () {
  if (window.location.href.indexOf("search") > -1) {
    document.title = "Search results";
  }
});

const userAgent = window.navigator.userAgent.toLowerCase(),
  ios = /iphone|ipod|ipad/.test(userAgent);

if (ios) {
  $(".mobile-navigation__wrap").css("padding-bottom", "115px");
}

function loadRewardsPopup() {
  if ($("#smile-ui-container").length > 0) {
    $("#smile-ui-container").css("z-index", "100");
    clearInterval(loadRewardsPopupId);
  }
}

let loadRewardsPopupId = window.setInterval(loadRewardsPopup, 500);

function loadChatPopup() {
  if ($(".BeaconFabButtonFrame").length > 0) {
    $(".BeaconFabButtonFrame").css("z-index", "19").css("z-index", "19");
    clearInterval(loadChatPopupId);
  }
}

let loadChatPopupId = window.setInterval(loadChatPopup, 500);

(function () {
  // jQuery('a.lightbox, [data-fancybox]').fancybox({
  //   parentEl: 'body',
  //   margin: [50, 0]
  // });

  Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    right: ["close"],
  });
  if (screen.width > 1023) {
    Fancybox.bind(".product__gallery-link[data-fancybox]", {
      Toolbar: {
        display: {
          right: ["close"],
        },
      },
      Carousel: {
        transition: "slide",
      },
    });
  }

  const players = Plyr.setup(".media-video");

  window.initProductGallery();

  jQuery("#Quantity").on("input", async function () {
    const input = jQuery(this);
    const inputWrap = input.parent();
    const inputMax = Number.parseInt(input.attr("max"));
    const inputvalue = Number.parseInt(input.val());
    const inputBtnInc = jQuery(inputWrap).find(".jcf-btn-inc");
    const inputBtnDec = jQuery(inputWrap).find(".jcf-btn-dec");

    if (inputvalue > inputMax) {
      input.val(inputMax);
      inputBtnInc.addClass("jcf-disabled");
      inputBtnDec.removeClass("jcf-disabled");
    } else {
      inputBtnInc.removeClass("jcf-disabled");
    }

    if (window["handleProductQtyMinMax"]) {
      try {
        const qtyInput = input[0];
        const productHandle = qtyInput.dataset.productHandle;
        const variantId = qtyInput.dataset.variantId;
        handleProductQtyMinMax(productHandle, variantId, qtyInput);
      } catch (ex) {}
    }

    setTimeout(() => {
      updateDiscountQuantityPrice();
    }, 300);
  });

  try {
    setTimeout(() => {
      jQuery("#Quantity").trigger("input");
    }, 100);
  } catch (ex) {}

  // ResponsiveHelper.addRange({
  //   '1280..': {
  //     on: function() {
  //       $('.product__gallery-link').zoom({
  //         magnify: 1.4
  //       })
  //     },
  //     off: function() {
  //       $('.product__gallery-link').zoom({
  //         magnify: 1.4
  //       })
  //     }
  //   }
  // });
})();

(function () {
  inView(
    ".viewport-section, .viewport-section-rte > *, .page-width--header"
  ).on("enter", (el) => {
    $(el).addClass("in-viewport");
  });

  $(window).on("beforeunload", function (event) {
    let $activeElement = $(event.target.activeElement);
    let href = $activeElement.attr("href");

    if (href) {
      if (href.includes("tel:") || href.includes("mailto:")) {
        return null;
      }
    }

    let isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(
        !window["safari"] ||
          (typeof safari !== "undefined" && safari.pushNotification)
      );

    if (!isSafari) {
      $("body").addClass("page-close");
    }
  });
})();

(function () {
  $(".bg-video").each(function () {
    jQuery(this).backgroundVideo({
      activeClass: "video-active",
    });
  });
})();

(function () {
  $(".js-product-row-gallery").each(function () {
    const swiperName = $(this).data("swiper");
    const swiperId = $(this).data("swiper-id");
    const nextArrow = ".swiper-button-next-" + swiperId;
    const prevArrow = ".swiper-button-prev-" + swiperId;
    const swiperSlider = ".swiper-slider-" + swiperId;

    const featuredGallery = new Swiper("[data-swiper=" + swiperName + "]", {
      spaceBetween: 13,
      slidesPerView: "1.645",
      allowTouchMove: true,
      watchOverflow: true,
      loop: false,
      speed: 800,
      pagination: {
        el: swiperSlider,
        type: "progressbar",
      },
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      breakpoints: {
        768: {
          spaceBetween: 40,
          allowTouchMove: true,
          slidesPerView: "2.645",
          pagination: {
            el: swiperSlider,
            type: "progressbar",
          },
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
        },
        1024: {
          spaceBetween: 50,
          allowTouchMove: false,
          slidesPerView: "3.645",
          pagination: {
            el: swiperSlider,
            type: "progressbar",
          },
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
        },
      },
    });
  });

  const swatchList = document.querySelectorAll("[data-variant-image]");
  if (!swatchList) {
    return;
  }

  swatchList.forEach((swatch) => {
    const swatchClick = function () {
      const parent = this.closest(".featured-product");
      const parent2 = this.closest(".product-information");
      if (parent) {
        const variantId = this.getAttribute("data-variant-image");

        const images = parent.querySelectorAll(".featured-product__image");

        const swatchElements = parent.querySelectorAll(".swatch-element");

        const variantPrices = parent.querySelectorAll(
          ".js-featured-product__price"
        );

        const link = parent.querySelectorAll(".js-featured-product__link");

        const tags = parent.querySelectorAll(".featured-product__tags");

        const swatchHeader = parent.querySelectorAll(".header span");

        if (images.length < 2) {
          return;
        }

        images.forEach((image) => {
          image.classList.add("hide");
          const imageVariant = image.getAttribute("data-value");
          const productUrl = image.getAttribute("data-href");

          if (variantId == imageVariant) {
            image.classList.remove("hide");
          }

          link.forEach((element) => {
            if (variantId == imageVariant) {
              element.href = productUrl + "?variant=" + imageVariant;
            }
          });
        });

        swatchElements.forEach((element) => {
          element.classList.remove("hover");
          this.closest(".swatch-element").classList.add("hover");
        });

        variantPrices.forEach((price) => {
          price.classList.add("hide");
          const priceVariant = price.getAttribute("data-variant-quantity");

          if (variantId == priceVariant) {
            price.classList.remove("hide");
          }
        });

        tags.forEach((element) => {
          element.classList.add("hide");
          const variantIdTag = element.getAttribute("data-tag-value");
          if (variantId == variantIdTag) {
            element.classList.remove("hide");
          }
        });

        swatchHeader.forEach((swatch) => {
          swatch.innerHTML = this.getAttribute("value");
        });
      }

      // for PDP
      if (parent2) {
        // console.log('swatch changed!!!!')

        const swatchElements = parent2.querySelectorAll(".swatch-element");

        const tags = parent2.querySelectorAll(".featured-product__tags");

        swatchElements.forEach((element) => {
          element.classList.remove("hover");
          this.closest(".swatch-element").classList.add("hover");
        });

        setTimeout(() => {
          const text = window.location.href.toString();
          const variantUrlId = text.replace(/^.*?variant=/i, "");

          tags.forEach((element) => {
            element.classList.add("hide");
            const variantIdTag = element.getAttribute("data-tag-value");
            if (variantUrlId == variantIdTag) {
              element.classList.remove("hide");
            }
            if ($(".featured-product__tags").length === 1) {
              element.classList.remove("hide");
            }
          });
        }, 100);

        if (window["handleProductQtyMinMax"]) {
          try {
            const qtyInput = document.querySelector("#Quantity");
            const productHandle = qtyInput.dataset.productHandle;
            const variantId = swatch.dataset.variantImage;
            handleProductQtyMinMax(productHandle, variantId, qtyInput);
          } catch (ex) {}
        }
      }
    };
    swatch.addEventListener("click", swatchClick);
    const isFiltered = swatch.closest("[data-filtered-color]");
    if (isFiltered) {
      swatch.checked = true;
      swatchClick.call(swatch);
    }
  });

  // Correct filtering with shopify sort
  // const pageUrl = window.location.href.toString();
  // const lowToHightSort = /sort_by=price-ascending/;
  // const hightToLowSort = /sort_by=price-descending/;

  // if (hightToLowSort.test(pageUrl) || lowToHightSort.test(pageUrl)) {
  //   setTimeout(() => {
  //     $('.featured-product__holder').each(function (index) {
  //       let arr = [];
  //       $(this).find('.js-featured-product__price').each(function () {
  //         let moneyToNumber = $(this).find(".money").text().replace(/[^0-9]/g, '');
  //         arr.push(+moneyToNumber)
  //       })

  //       let limits = arr.reduce(function(limits, element, index, array){
  //         limits.max = element > array[limits.max] ? index : limits.max;
  //         limits.min = element < array[limits.min] ? index : limits.min;
  //         return limits;
  //       }, { max : 0, min : 0 });

  //       $(this).find('.js-featured-product__price').each(function (index) {
  //         $(this).addClass('hide')
  //         if(index === limits.min) {
  //           $(this).removeClass('hide')
  //         }
  //       })

  //       $(this).find('.swatch-element.color').each(function (index) {
  //         $(this).removeClass('hover')
  //         if(index === limits.min) {
  //           $(this).addClass('hover')
  //         }
  //       })

  //       $(this).find('.featured-product__image:not(.featured-product__image--hover)').each(function (index) {
  //         $(this).addClass('hide')
  //         if(index === limits.min) {
  //           $(this).removeClass('hide')
  //         }
  //       })
  //       arr = [];
  //     })
  //   },100)
  // }
})();
(function () {
  ResponsiveHelper.addRange({
    "..767": {
      on: function () {
        jQuery(".js-brand-value").slick({
          slidesToScroll: 1,
          slidesToShow: 1,
          rows: 0,
          arrows: false,
          dots: true,
          infinite: false,
          variableWidth: true,
        });
      },
      off: function () {
        jQuery(".js-brand-value").slick("unslick");
      },
    },
  });
})();

(function () {
  ResponsiveHelper.addRange({
    "..767": {
      on: function () {
        jQuery(".js-footer__menu-block").openClose({
          activeClass: "active",
          opener: ".js-opener",
          slider: ".js-footer-menu",
          animSpeed: 400,
          effect: "slide",
        });
      },
      off: function () {
        jQuery(".js-footer__menu-block").openClose("destroy");
      },
    },
  });

  $(".live-chat a").on("click", function () {
    $('[aria-label="Toggle Customer Support"]')
      .contents()
      .find('[aria-label="Open Beacon popover"]')
      .trigger("click");
  });
})();

(function () {
  const swatchElement = document.querySelectorAll(
    ".hero-product .swatch-element"
  );
  const heroProductGallery = $(".hero-product__gallery");
  const heroImgBlock = $(".hero-product__img-block");

  swatchElement.forEach((element) => {
    element.addEventListener("click", function () {
      heroProductGallery.removeClass("hide");
      heroImgBlock.addClass("hide");
    });
  });
})();
(function () {
  jQuery(".general-form__row").addFocusClass({
    focusClass: "input-focused",
    stayFocusOnFilled: true,
  });

  jQuery(".js-validation").formValidation({
    errorClass: "general-form__error",
    addClassToParent: ".general-form__row",
  });

  jQuery(".template-product .shopify-product-form").formValidation({
    errorClass: "line-item__error",
    addClassToParent: ".line-item-property__field",
    errorFormClass: "form__error",
  });

  jQuery("#create_customer #CreatePassword").passwordValidation(
    { confirmField: "#myConfirmPassword" },
    function (element, valid, match, failedCases) {
      $("#errors").html("<pre>" + failedCases.join("\n") + "</pre>");
      if (valid)
        $(element).css("border-bottom", "1px solid rgba(0, 0, 0, 0.5)");
      if (!valid) $(element).css("border-bottom", "1px solid #eb5757");
    }
  );

  jQuery(".protected-password__link a").on("click", function () {
    $(".protected-password__login").removeClass("hide");
    $(".password-protected__main").addClass("hide");
  });

  const targetButtons = jQuery(".js-password");

  targetButtons.each(function () {
    const input = jQuery(this).find(".js-placeholder-input");
    const link = jQuery(this).find(".js-password-link");

    link.on("click", function () {
      if (input.attr("type") === "password") {
        input.attr("type", "text");
        link.addClass("shown");
      } else {
        input.attr("type", "password");
        link.removeClass("shown");
      }
    });
  });

  jcf.setOptions("Select", {
    wrapNative: false,
  });
  jcf.replaceAll();

  function loadCrossSell() {
    const crossSellBlock = jQuery(".cross-sell-block .nudge-offer");
    if (crossSellBlock.length > 0) {
      clearInterval(loadCrossSellID);
      jcf.replaceAll();
    }
  }

  let loadCrossSellID = window.setInterval(loadCrossSell, 500);
})();

// =require blocks/newsletter-popup.js
(function () {
  // initialize smooth anchor links
  setTimeout(function () {
    new SmoothScroll({
      extraOffset: $(".section--header").height() || 0,
      anchorLinks: ".faq__headings-link",
      activeClasses: "parent",
      wheelBehavior: "ignore",
      animDuration: 800,
    });
  }, 1000);

  if ($(".faq__page-width").length > 0) {
    $(window).scroll(function () {
      var wt = $(window).scrollTop();
      var wh = $(window).height();
      var et = $(".faq__page-width").offset().top;
      var eh = $(".faq__page-width").outerHeight();
      var dh = $(document).height();
      if (wt + wh >= et || wh + wt == dh || eh + et < wh) {
        setTimeout(function () {
          new SmoothScroll({
            extraOffset: $(".section--header").height() || 0,
            anchorLinks: ".faq__headings-link",
            activeClasses: "parent",
            wheelBehavior: "ignore",
            animDuration: 800,
          });
        }, 1000);
      }
    });
  }

  const builderLinks = $(".page-builder-link");

  builderLinks.each(function () {
    const elemHref = $(this).attr("href");
    const regex = new RegExp("#");
    if (!regex.test(elemHref)) {
      $(this).removeClass("builder-anchor-link");
    }
  });

  new SmoothScroll({
    extraOffset: $(".section--header").height() || 0,
    anchorLinks: ".builder-anchor-link",
    activeClasses: "parent",
    wheelBehavior: "ignore",
    animDuration: 800,
  });

  jQuery(".js-toggle-item").openClose({
    activeClass: "active",
    opener: ".js-toggle-link",
    slider: ".js-toggle-content",
    animSpeed: 400,
    hideOnClickOutside: false,
    effect: "slide",
  });

  jQuery(".js-mobile-toggle-item").openClose({
    activeClass: "active",
    opener: ".js-mobile-toggle-link",
    slider: ".js-mobile-toggle-content",
    animSpeed: 400,
    hideOnClickOutside: true,
    effect: "none",
  });

  let timerId = setTimeout(function tick() {
    if ($("div[class*='TextInput__StyledInputContainer-']").length) {
      const inputBox = $("div[class*='TextInput__StyledInputContainer-']");
      const newsletterInput = $(
        "div[class*='TextInput__StyledInputContainer-'] input"
      );
      $(newsletterInput).after(
        "<label for='CustomerEmail' class='general-form__label'>Your email</label>"
      );
      $(newsletterInput).addClass("general-form__input");
      $(inputBox).addClass("general-form__row ");

      jQuery(".general-form__row").addFocusClass({
        focusClass: "input-focused",
        stayFocusOnFilled: true,
      });
    } else {
      timerId = setTimeout(tick, 500);
    }
    setTimeout(function () {
      clearTimeout(timerId);
    }, 10000);
  }, 500);
})();

(function () {
  let sticky;

  $(".swatch-element").each(function () {
    $(this).on("click", function (e) {
      setTimeout(() => {
        sticky.trigger("resize");
      }, 1000);
    });
  });

  setTimeout(() => {
    sticky = jQuery(".shopify-product-form").stickyScrollBlock({
      setBoxHeight: true,
      activeClass: "shopify-product--fixed",
      container: "#shopify-section-header",
      positionType: "fixed",
      extraTop: function () {
        var totalHeight = 0;
        jQuery("0").each(function () {
          totalHeight += jQuery(this).outerHeight();
        });
        return totalHeight;
      },
      showAfterScrolled: true,
    });
    sticky.trigger("resize");
  }, 3000);

  new SmoothScroll({
    anchorLinks: "a.sticky-btn",
    extraOffset: 0,
    wheelBehavior: "none",
  });

  new SmoothScrollPdp({
    anchorLinks: ".product-anchor",
    extraOffset: 0,
    wheelBehavior: "stop",
    activeClasses: "parent",
  });

  $(".product-anchor").each(function () {
    $(this).on("click", function (e) {
      setTimeout(() => {
        const newHeight = $(".swatch__wrap").outerHeight();
        $(".product-info").css({
          "padding-top": newHeight,
          "margin-top": -newHeight,
        });
        $(".product-description__wrap").css({
          "padding-top": newHeight,
          "margin-top": -newHeight,
        });
      }, 800);
    });
  });
})();

(function () {
  const miniCartTrigger = jQuery("[data-mini-cart-trigger]");
  const miniCartActive = "mini-cart--shown";
  const miniCartParent = jQuery("[data-mini-cart]");
  const cartCount = jQuery("[data-cart-count]");
  const cartTotal = jQuery("[data-cart-total]");
  const cartFull = jQuery("[data-full-cart-content]");
  const cartEmpty = jQuery("[data-empty-cart-content]");
  const giftId = jQuery("[data-gift-product]");

  $(".mini-cart__footer-button").on("click touchend", function (e) {
    setTimeout(function () {
      let textareaValue = document.getElementById("gift-note").value;
      CartJS.setNote(textareaValue);
      // $('#CartSpecialInstructions').val(textareaValue);
    }, 500);
  });

  let textareaValue = document.getElementById("gift-note").value;
  $("#CartSpecialInstructions").val(textareaValue);
  function loadCart(event, cart) {
    console.log("-----------loadCart-------------");
    const cartItems = cart.items;
    const rimCartTotal = cart.original_total_price;
    const priceElem = $(".js-price-without-currency");

    priceElem.each(function () {
      const priceElemReplaced = $(this).text().replace("USD", "");
      $(this).text("");
      $(this).text(priceElemReplaced);
    });

    cartItems.forEach((elem, index) => {
      const items = $("[data-gift-item-id]");
      $(items).removeClass("js-cart-item-discount");
      if (
        elem.properties.hasOwnProperty("EntrieOrderGiftWrap") &&
        elem.properties.EntrieOrderGiftWrap == "Yes"
      ) {
        $("#gift-note").val(elem.properties.OrderGiftNote);
        $("#CartSpecialInstructions").val(elem.properties.OrderGiftNote);
        //CartJS.setNote(elem.properties.OrderGiftNote);
      }
      if (elem.properties.hasOwnProperty("_Volume order")) {
        const currentItem = "[data-gift-item-id=" + elem.id + "]";
        const salePriceDiv = "[data-list-item-price-sale=" + elem.id + "]";
        const priceDiv = "[data-list-item-price=" + elem.id + "]";
        const salePrice =
          ".mini-cart__prices--discount .minicart__list-item-price-sale";
        const salePriceCartPage =
          ".cart-table__product-price-holder--discount .cart-table__list-item-price-sale";
        const currentPrice =
          ".mini-cart__prices--discount .minicart__list-item-price";
        const currentPriceCartPage =
          ".cart-table__product-price-holder--discount .cart-table__discount-text";
        // const salePriceDecimal = ((elem.original_line_price / 100).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // const currentPriceDecimal = ((elem.final_line_price / 100).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const salePriceDecimal = elem.original_price
          .toString()
          .replace(/\B(?=(\d{2})+(?!\d))/g, ".");
        const currentPriceDecimal = elem.final_price
          .toString()
          .replace(/\B(?=(\d{2})+(?!\d))/g, ".");
        const salePriceCartPageDecimal = (elem.final_line_price / 100)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        if (elem.discounts.length > 0) {
          const discountQty = elem.discounts[0].title;
          const discountHtml =
            `<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.19077 1.29534C7.67253 1.40842 7.22044 1.72274 6.93395 2.16915L0.360019 12.4127C-0.236565 13.3423 0.0334006 14.5795 0.963004 15.1761L7.69578 19.497C8.62539 20.0935 9.86261 19.8236 10.4592 18.894L17.0331 8.65041C17.3196 8.204 17.417 7.66207 17.3039 7.14383L16.098 1.61702C15.8625 0.537838 14.7968 -0.146113 13.7176 0.0893672L8.19077 1.29534ZM12.5009 5.99975C13.3294 5.99975 14.0009 5.32818 14.0009 4.49975C14.0009 3.67133 13.3294 2.99975 12.5009 2.99975C11.6725 2.99975 11.0009 3.67133 11.0009 4.49975C11.0009 5.32818 11.6725 5.99975 12.5009 5.99975Z" fill="#8B8480"/>
          </svg>` + discountQty.substr(0, 8);
          setTimeout(function () {
            $(currentItem).addClass("js-cart-item-discount");
          }, 10);
          $("._Volume").removeClass("hide");
          $(
            `.mini-cart__item-box .mini-cart__item:nth-child(${
              index + 1
            }) ._Volume`
          ).text("Volume order: " + elem.quantity);
          $(salePriceDiv).text("$" + salePriceDecimal + " USD");
          $(priceDiv).text("$" + currentPriceDecimal + " USD");
          $(salePriceCartPage).text("$" + salePriceCartPageDecimal);
          //$(currentPriceCartPage).html(discountHtml);
        } else {
          $("._Volume").addClass("hide");
        }
      } else if (rimCartTotal >= 7500) {
        const currentItem = "[data-gift-item-id=" + elem.id + "]";
        const salePriceDiv = "[data-list-item-price-sale=" + elem.id + "]";
        const priceDiv = "[data-list-item-price=" + elem.id + "]";
        const salePrice =
          ".mini-cart__prices--discount .minicart__list-item-price-sale";
        const salePriceCartPage =
          ".cart-table__product-price-holder--discount .cart-table__list-item-price-sale";
        const currentPrice =
          ".mini-cart__prices--discount .minicart__list-item-price";
        const currentPriceCartPage =
          ".cart-table__product-price-holder--discount .cart-table__discount-text";
        const salePriceDecimal = (elem.original_line_price / 100)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const currentPriceDecimal = (elem.final_line_price / 100)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const salePriceCartPageDecimal = (elem.final_line_price / 100)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (elem.discounts.length > 0) {
          setTimeout(function () {
            $(currentItem).addClass("js-cart-item-discount");
          }, 10);
          $(salePriceDiv).text("$" + salePriceDecimal + " USD");
          $(priceDiv).text("$" + currentPriceDecimal + " USD");
          $(salePriceCartPage).text("$" + salePriceCartPageDecimal);
        }
      }
    });

    let textareaValue = document.getElementById("gift-note").value;
    $("#CartSpecialInstructions").val(textareaValue);

    function loadCrossSellAjax() {
      setTimeout(function () {
        const crossSellBlockAjax = jQuery(
          ".ajax-cross-sell-block .nudge-offer"
        );
        if (crossSellBlockAjax) {
          clearInterval(loadCrossSellIDAjax);
          jcf.replaceAll();
        }
      }, 3000);
    }
    let loadCrossSellIDAjax = window.setInterval(loadCrossSellAjax, 500);

    let messageContainer = document.querySelectorAll(".js-gift-message");
    messageContainer.forEach(function (elem) {
      let spanId = elem.getAttribute("data-gift-id");
      if (giftId.attr("data-gift-product") == spanId) {
        if (textareaValue) {
          elem.innerHTML = "Message: " + textareaValue;
        } else {
          elem.innerHTML = "";
        }
      }
    });

    $(".mini-cart__item-remove, .cart-table__product-remove").on(
      "click",
      function (e) {
        let removedItem = e.target.getAttribute("data-remove-item-id");

        if (giftId.attr("data-gift-product") == removedItem) {
          document.getElementById("gift-wrapping").checked = false;
          if ($(".js-gift-cart").hasClass("js-gift-cart--active")) {
            $(".js-gift-cart-opener").trigger("click");
          }
        }
      }
    );

    $(".mini-cart__property-value").each(function () {
      const elem = $(this).html();
      if (elem == "") {
        $(this).parent().addClass("hide");
      }
    });
    let oldElem = null;
    $(".mini-cart__item-option").each(function () {
      if (
        $.trim($(this).text()) === "Monogram" ||
        $.trim($(this).text()) === "None" ||
        $.trim($(this).text()) === "Add Monogram" ||
        $.trim($(this).text()) === "No Monogram"
      ) {
        $(this).addClass("hide");
        if (oldElem) {
          $(oldElem).addClass("no-separate");
        }
      }
      oldElem = $(this);
    });

    $(".cart-table__product-option").each(function () {
      if (
        $.trim($(this).text()) === "Monogram" ||
        $.trim($(this).text()) === "None" ||
        $.trim($(this).text()) === "Add Monogram" ||
        $.trim($(this).text()) === "No Monogram" ||
        $.trim($(this).text()).indexOf("% off)") != -1
      ) {
        $(this).addClass("hide");
        if (oldElem) {
          $(oldElem).addClass("no-separate");
        }
      }
      oldElem = $(this);
    });

    $(".mini-cart__property-name").each(function () {
      if ($.trim($(this).text()) === "Select font:") {
        $(this).text("Font:");
      }
      if ($.trim($(this).text()) === "Monogram Text:") {
        $(this).text("Monogram text:");
      }
    });
  }

  $(document).ready(function () {
    window.allowAlphaNumericSpace = function (e) {
      var code = "charCode" in e ? e.charCode : e.keyCode;
      if (
        !(code == 32) && // space
        !(code == 33) &&
        !(code == 34) &&
        !(code == 39) &&
        !(code == 42) &&
        !(code == 44) &&
        !(code == 45) &&
        !(code == 46) &&
        !(code == 47) &&
        !(code == 58) &&
        !(code == 59) &&
        !(code == 63) &&
        !(code == 64) &&
        !(code == 91) &&
        !(code == 93) &&
        !(code == 95) &&
        !(code == 123) &&
        !(code == 125) &&
        !(code > 47 && code < 58) && // numeric (0-9)
        !(code > 64 && code < 91) && // upper alpha (A-Z)
        !(code > 96 && code < 123)
      ) {
        // lower alpha (a-z)
        e.preventDefault();
      }
    };
  });

  function updateCart(event, cart) {
    console.log("-----------updateCart-------------");
    cartCount.html(cart.item_count);
    cartTotal.html(Shopify.formatMoney(cart.items_subtotal_price));
    checkVariantLimit();
    console.log("cart.item_count------------>",cart.item_count);
    if (!miniCartParent.hasClass(miniCartActive)) {
      miniCartParent.addClass(miniCartActive);
    }

    if (cart.item_count === 0) {
      cartCount.addClass("hide");
      cartFull.addClass("hide");
      cartEmpty.removeClass("hide");
    } else {
      cartCount.removeClass("hide");
      cartFull.removeClass("hide");
      cartEmpty.addClass("hide");
    }

    const cartItems = cart.items;
    const rimCartTotal = cart.original_total_price;
    const priceElem = $(".js-price-without-currency");
    const miniCartItem = $(".mini-cart__item");
    const cartItem = $(".cart-table__tr ");
    const giftItem = giftId.attr("data-gift-product");
    const giftItemExist = $("[data-gift-item-id=" + giftItem + "]");

    priceElem.each(function () {
      const priceElemReplaced = $(this).text().replace("USD", "");
      $(this).text("");
      $(this).text(priceElemReplaced);
    });

    cartItems.forEach((elem, index) => {
      console.log("elem----------->",elem);
      const items = $("[data-gift-item-id]");
      $(items).removeClass("js-cart-item-discount");
      if (
        elem.properties.hasOwnProperty("EntrieOrderGiftWrap") &&
        elem.properties.EntrieOrderGiftWrap == "Yes"
      ) {
        $("#gift-note").val(elem.properties.OrderGiftNote);
        $("#CartSpecialInstructions").val(elem.properties.OrderGiftNote);
        //CartJS.setNote(elem.properties.OrderGiftNote);
      }
      if (elem.properties.hasOwnProperty("_Volume order")) {
        const currentItem = "[data-gift-item-id=" + elem.id + "]";
        const salePriceDiv = "[data-list-item-price-sale=" + elem.id + "]";
        const priceDiv = "[data-list-item-price=" + elem.id + "]";
        const salePrice =
          ".mini-cart__prices--discount .minicart__list-item-price-sale";
        const salePriceCartPage =
          ".cart-table__product-price-holder--discount .cart-table__list-item-price-sale";
        const currentPrice =
          ".mini-cart__prices--discount .minicart__list-item-price";
        const currentPriceCartPage =
          ".cart-table__product-price-holder--discount .cart-table__discount-text";
        // const salePriceDecimal = ((elem.original_line_price / 100).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // const currentPriceDecimal = ((elem.final_line_price / 100).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const salePriceDecimal = elem.original_price
          .toString()
          .replace(/\B(?=(\d{2})+(?!\d))/g, ".");
        const currentPriceDecimal = elem.final_price
          .toString()
          .replace(/\B(?=(\d{2})+(?!\d))/g, ".");
        const salePriceCartPageDecimal = (elem.final_line_price / 100)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        if (elem.discounts.length > 0) {
          const discountQty = elem.discounts[0].title;
          const discountHtml =
            `<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.19077 1.29534C7.67253 1.40842 7.22044 1.72274 6.93395 2.16915L0.360019 12.4127C-0.236565 13.3423 0.0334006 14.5795 0.963004 15.1761L7.69578 19.497C8.62539 20.0935 9.86261 19.8236 10.4592 18.894L17.0331 8.65041C17.3196 8.204 17.417 7.66207 17.3039 7.14383L16.098 1.61702C15.8625 0.537838 14.7968 -0.146113 13.7176 0.0893672L8.19077 1.29534ZM12.5009 5.99975C13.3294 5.99975 14.0009 5.32818 14.0009 4.49975C14.0009 3.67133 13.3294 2.99975 12.5009 2.99975C11.6725 2.99975 11.0009 3.67133 11.0009 4.49975C11.0009 5.32818 11.6725 5.99975 12.5009 5.99975Z" fill="#8B8480"/>
          </svg>` + discountQty.substr(0, 8);
          setTimeout(function () {
            $(currentItem).addClass("js-cart-item-discount");
          }, 10);
          $("._Volume").removeClass("hide");
          $(
            `.mini-cart__item-box .mini-cart__item:nth-child(${
              index + 1
            }) ._Volume`
          ).text("Volume order: " + elem.quantity);
          $(salePriceDiv).text("$" + salePriceDecimal + " USD");
          $(priceDiv).text("$" + currentPriceDecimal + " USD");
          $(salePriceCartPage).text("$" + salePriceCartPageDecimal);
          //$(currentPriceCartPage).html(discountHtml);
        } else {
          $("._Volume").addClass("hide");
        }
      } else if (rimCartTotal >= 7500) {
        const currentItem = "[data-gift-item-id=" + elem.id + "]";
        const salePriceDiv = "[data-list-item-price-sale=" + elem.id + "]";
        const priceDiv = "[data-list-item-price=" + elem.id + "]";
        const salePrice =
          ".mini-cart__prices--discount .minicart__list-item-price-sale";
        const salePriceCartPage =
          ".cart-table__product-price-holder--discount .cart-table__list-item-price-sale";
        const currentPrice =
          ".mini-cart__prices--discount .minicart__list-item-price";
        const currentPriceCartPage =
          ".cart-table__product-price-holder--discount .cart-table__discount-text";
        const salePriceDecimal = (elem.original_line_price / 100)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const currentPriceDecimal = (elem.final_line_price / 100)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const salePriceCartPageDecimal = (elem.final_line_price / 100)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (elem.discounts.length > 0) {
          setTimeout(function () {
            $(currentItem).addClass("js-cart-item-discount");
          }, 10);
          $(salePriceDiv).text("$" + salePriceDecimal + " USD");
          $(priceDiv).text("$" + currentPriceDecimal + " USD");
          $(salePriceCartPage).text("$" + salePriceCartPageDecimal);
        }
      }
    });

    function loadCrossSellAjax() {
      setTimeout(function () {
        const crossSellBlockAjax = jQuery(
          ".ajax-cross-sell-block .nudge-offer"
        );
        if (crossSellBlockAjax) {
          clearInterval(loadCrossSellIDAjax);
          jcf.replaceAll();
        }
      }, 3000);
    }

    let loadCrossSellIDAjax = window.setInterval(loadCrossSellAjax, 500);
    let textareaValue = document.getElementById("gift-note").value;

    let messageContainer = document.querySelectorAll(".js-gift-message");
    messageContainer.forEach(function (elem) {
      let spanId = elem.getAttribute("data-gift-id");
      if (giftId.attr("data-gift-product") == spanId) {
        if (textareaValue) {
          elem.innerHTML = "Message: " + textareaValue;
        } else {
          elem.innerHTML = "";
        }
      }
      if (
        (miniCartItem.length == 1 && giftItemExist.length > 0) ||
        (cartItem.length == 1 && giftItemExist.length > 1)
      ) {
        CartJS.removeItemById(giftItem);
        document.getElementById("gift-wrapping").checked = false;
      }
    });

    $(".mini-cart__item-remove, .cart-table__product-remove").on(
      "click",
      function (e) {
        let removedItem = e.target.getAttribute("data-remove-item-id");

        if (giftId.attr("data-gift-product") == removedItem) {
          document.getElementById("gift-wrapping").checked = false;
          if ($(".js-gift-cart").hasClass("js-gift-cart--active")) {
            $(".js-gift-cart-opener").trigger("click");
          }
        }
      }
    );

    $(".mini-cart__property-value").each(function () {
      const elem = $(this).html();
      $(this).parent().removeClass("hide");
      if (elem == "") {
        $(this).parent().addClass("hide");
      }
    });

    let oldElem = null;
    $(".mini-cart__item-option").each(function () {
      if (
        $.trim($(this).text()) === "Monogram" ||
        $.trim($(this).text()) === "None" ||
        $.trim($(this).text()) === "Add Monogram" ||
        $.trim($(this).text()) === "No Monogram"
      ) {
        $(this).addClass("hide");
        if (oldElem) {
          $(oldElem).addClass("no-separate");
        }
      }
      oldElem = $(this);
    });

    $(".cart-table__product-option").each(function () {
      if (
        $.trim($(this).text()) === "Monogram" ||
        $.trim($(this).text()) === "None" ||
        $.trim($(this).text()) === "Add Monogram" ||
        $.trim($(this).text()) === "No Monogram"
      ) {
        $(this).addClass("hide");
        if (oldElem) {
          $(oldElem).addClass("no-separate");
        }
      }
      oldElem = $(this);
    });

    $(".mini-cart__property-name").each(function () {
      if ($.trim($(this).text()) === "Select font:") {
        $(this).text("Font:");
      }
      if ($.trim($(this).text()) === "Monogram Text:") {
        $(this).text("Monogram text:");
      }
    });
  }
  $(document).on("cart.ready", function (event, cart) {
    //if (!localStorage.getItem("country")) {
    //$.get("https://ipinfo.io?token=8f12d536d96bb6", function(response) {
    //localStorage.setItem("country", response.country);
    loadCart(event, cart);
    freeShippingSlider(cart, "US");
    //});
    /* } else {
        loadCart(event, cart);
        freeShippingSlider(cart, localStorage.country);
    }*/
  });

  jQuery(document).on("cart.requestComplete", function (event, cart) {
    /* if (!localStorage.getItem("country")) {
        $.get("https://ipinfo.io?token=8f12d536d96bb6", function(response) {
            localStorage.setItem("country", response.country);
            updateCart(event, cart);
            freeShippingSlider(cart, response.country);
        });
    } else {*/
    updateCart(event, cart);
    freeShippingSlider(cart, "US");
    //}
  });

  jQuery(document).on("input", "[data-variant]", async function () {
    
    var $this = jQuery(this);

    let line = Number.parseInt($this.attr("data-variant")),
      qty = Number.parseInt($this.val()),
      minQty = 1,
      maxQty = 1;
    if (window["verifyProductAddToCart"]) {
      try {
        const lineItem = window?.cartData?.items?.find(
          (item, itemIndex) => itemIndex + 1 === line
        );
        if (lineItem) {
          const { variant_id } = lineItem;
          const possibleAmount = await verifyProductAddToCart(
            +variant_id,
            +qty
          );
          qty = possibleAmount;
        }
      } catch (ex) {
        console.error(ex);
      }
    }

    CartJS.updateItem(line, qty);
  });

  function addMiniCartTrigger(e) {
    e.preventDefault();
    jQuery.getJSON("/cart.js", function (cart) {
      const newCart = cart;
      setTimeout(function () {
        // loadCart(e, newCart);
        //updateCart(e, newCart);
        miniCartParent.toggleClass(miniCartActive);
      }, 0);
    });
  }

  //Add product.json.liquid
  function checkVariantLimit() {
    const cartItemParent = jQuery("[data-minicart-item]");

    if (cartItemParent.length < 1) {
      return;
    }

    cartItemParent.each(function () {
      const item = jQuery(this);
      const cartItem = item.find("[data-compare-price]");
      const cartItemPrice = item
        .find("[data-price]")
        .attr("data-minicart-price");
      const cartItemFullUrl = cartItem.attr("data");
      const cartItemUrl = cartItemFullUrl.split("?")[0];
      const cartItemVariant = cartItemFullUrl.split("?")[1].split("=")[1];
      const cartItemQty = item.find("[data-item-qty]").val();
      const cartItemBtnPlus = item.find("[data-qty-number-plus]");
      const cartItemMessage = item.find("[data-limit-message]");
      const salePriceAllProduct =
        ".cart-table__product-price-holder .js-price-without-currency";

      jQuery.getJSON(cartItemUrl + ".js", function (product) {
        if (product.url !== cartItemUrl) {
          return;
        }
        cartItem.addClass("hide");

        jQuery(product.variants).each(function () {
          if (
            this.id == cartItemVariant &&
            cartItemPrice < this.compare_at_price
          ) {
            cartItem.html(
              Shopify.formatMoney(this.compare_at_price, theme.moneyFormat)
            );
            cartItem.removeClass("hide");
          }

          if (this.id == cartItemVariant) {
            fetch(`${cartItemUrl}?view=json`, {
              redirect: "follow",
              credentials: "include",
            }).then((response) => {
              response.json().then(function (parsedJson) {
                jQuery(parsedJson.option).each(function () {
                  let variant = Number.parseInt(cartItemVariant);
                  if (this[variant]) {
                    if (this[variant] == cartItemQty) {
                      // cartItemMessage.removeClass('hide');
                      cartItemBtnPlus.addClass("btn-disabled");
                    } else {
                      cartItemMessage.addClass("hide");
                      cartItemBtnPlus.removeClass("btn-disabled");
                    }
                  }
                });
              });
            });
          }
        });
      });
    });
  }

  miniCartTrigger.click(addMiniCartTrigger);
  setTimeout(checkVariantLimit, 100);

  jQuery(".js-gift-cart").openClose({
    activeClass: "js-gift-cart--active",
    opener: ".js-gift-cart-opener",
    slider: ".js-gift-cart-slide",
    animSpeed: 400,
    effect: "slide",
  });

function waitForElement(selector, callback) {
  const el = document.querySelector(selector);
  if (el) {
    callback(el);
  } else {
    setTimeout(() => waitForElement(selector, callback), 100);
  }
}

// waitForElement('.rbu-sb-btn', function(button) {
//   button.addEventListener('click', function() {
//     setTimeout(() => {
//       const url = new URL(window.location.href);
//       url.searchParams.set('open_cart', 'true');
//       window.location.href = url.toString();
//     }, 1500); // adjust delay as needed
//   });
// });

//   document.addEventListener('DOMContentLoaded', function() {
//   const urlParams = new URLSearchParams(window.location.search);
//   if (urlParams.get('open_cart') === 'true') {
//     if (!miniCartParent.hasClass(miniCartActive)) {
//       miniCartParent.addClass(miniCartActive);
//     }
//   }
// });
function waitForElement(selector, callback) {
  const el = document.querySelector(selector);
  if (el) return callback(el);

  const observer = new MutationObserver((mutations, obs) => {
    const el = document.querySelector(selector);
    if (el) {
      obs.disconnect();
      callback(el);
    }
  });

  observer.observe(document, {
    childList: true,
    subtree: true
  });
}

function setupCartTrigger(selector) {
  waitForElement(selector, function(button) {
    button.addEventListener('click', function () {
      setTimeout(() => {
        const url = new URL(window.location.href);
        url.searchParams.set('open_cart', 'true');
        window.location.href = url.toString();
      }, 1500); // adjust delay if needed
    });
  });
}

// Apply to both buttons
setupCartTrigger('.rbu-sb-btn');
setupCartTrigger('.rbu-qb-btn');

// Open cart drawer if URL param is present
document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('open_cart') === 'true') {
    if (!miniCartParent.hasClass(miniCartActive)) {
      miniCartParent.addClass(miniCartActive);
    }
  }
});

})();



(function () {
  const btnReset = jQuery(".btn-search__close");
  if (btnReset) {
    jQuery(btnReset).on("click", function (e) {
      e.preventDefault();

      const input = jQuery(btnReset)
        .parent()
        .find(".search-form__input-header, .search-form__input-search");
      jQuery(input).val("").focus();
    });
  }

  const body = jQuery("body");
  if (jQuery.cookie("cookies_first_visited") === "1") {
    body.removeClass("first-visited");
  } else {
    body.addClass("first-visited");
  }
  jQuery.cookie("cookies_first_visited", "1");

  window.unload = function () {
    jQuery.removeCookie("cookies_first_visited");
  };

  jQuery(".js-search__opener").on({
    click: function () {
      body.removeClass(`first-visited`);
      const input = jQuery("#search-form__input-header");
      jQuery(input[0]).focus();
    },
  });
})();

(function () {
  ResponsiveHelper.addRange({
    "..1023": {
      on: function () {
        jQuery(".js-mobile-account-dropbox").openClose({
          activeClass: "active",
          opener: ".js-mobile-account-opener",
          slider: ".js-mobile-account-menu",
          animSpeed: 400,
          effect: "none",
        });
      },
      off: function () {
        jQuery(".js-mobile-account-dropbox").openClose("destroy");
      },
    },
  });
})();

(function () {
  const mailtoHref = $(".social-sharing__link-email").attr("href");
  const articleUrl = window.location.href.toString();
  // console.log(articleUrl);
  $(".social-sharing__link-email").attr(
    "href",
    mailtoHref + "&body=" + articleUrl
  );
})();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register("product", theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = ".rte table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "rte__table-wrapper",
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "rte__video-wrapper",
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className =
      document.documentElement.className.replace(
        "supports-no-cookies",
        "supports-cookies"
      );
  }
});

const textTargetedLinks = document.querySelectorAll(`[href^='#']`);
const allSections = Array.from(
  document.querySelectorAll(".shopify-section, .viewport-section")
);
textTargetedLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    const hash = link.hash;
    const text = decodeURI(hash).slice(1);
    const foundSection = allSections.find((section) =>
      section.innerText.includes(text)
    );
    if (!foundSection) return;
    e.preventDefault();
    foundSection.scrollIntoView({ behavior: "smooth" });
  });
});

async function saveGlobalCartData() {
  try {
    const res = await fetch("/cart.js");
    if (!res.ok) throw new Error("Something went wrong");
    const cartData = await res.json();
    window.cartData = cartData;
    // console.log({ cartData })
  } catch (ex) {
    console.error(ex);
  }
}

saveGlobalCartData();

function onDigitalProductDownload(evt) {
  const encoded = evt.target.dataset.encoded;

  if (_learnq.isIdentified()) {
    window.open(atob(atob(encoded)), "_blank");
  } else {
    const _klOnsite = window._klOnsite || [];
    _klOnsite.push(["openForm", "XKqHNJ"]);
  }
}

$(".js-download-digital-product").on("click", onDigitalProductDownload);

/***********
RECHARGE WIDGET CODE
***********/
function initializeWidget() {
  //initialize frequency select
  let frequencyHTML = "";
  const productJSON = JSON.parse($("#product-json").text());
  const sellingplans = productJSON.selling_plan_groups[0].selling_plans;
  //console.log(sellingplans);
  //console.log(productJSON);
  for (sellingplan in sellingplans) {
    if (sellingplan == 0) {
      if (
        sellingplans[sellingplan]["price_adjustments"][0]["value_type"] ==
        "percentage"
      ) {
        const percentOff =
          sellingplans[sellingplan]["price_adjustments"][0]["value"] / 100;
        let newPrice = productJSON.price - productJSON.price * percentOff;
        newPrice = `$${parseFloat(newPrice / 100).toFixed(2)}`;
        $(".custom-subsave-price").html(newPrice);
      } else {
        const amtOff =
          sellingplans[sellingplan]["price_adjustments"][0]["value"];
        let newPrice = productJSON.price - amtOff;
        newPrice = `$${parseFloat(newPrice / 100).toFixed(2)}`;
        $(".custom-subsave-price").html(newPrice);
      }

      $(".custom-otp-price").html(sellingplans[sellingplan].price);
      $('input[name="selling_plan"]').attr(
        "data-value",
        sellingplans[sellingplan].id
      );
      $('input[name="subscription_frequency"]').attr(
        "data-value",
        sellingplans[sellingplan].name
      );
      frequencyHTML += `<div class="custom-frequency-selected"><span class="frequency-name">${sellingplans[sellingplan].name}</span></div><div class="custom-frequency-option-container">`;
    }
    frequencyHTML += `<div class="custom-frequency-option" data-selling-plan="${sellingplans[sellingplan].id}" data-frequency-text="${sellingplans[sellingplan].name}">`;
    frequencyHTML += `<span class="custom-frequency-option-text">${sellingplans[sellingplan].name}</span>`;
    frequencyHTML += "</div>";

    if (sellingplan == sellingplans.length) {
      frequencyHTML += "</div>";
    }
  }

  $(".custom-frequency-select").append(frequencyHTML);

  $("body").on("click", ".custom-frequency-selected", function (e) {
    let freqSelect = $(this)
      .parent()
      .find(".custom-frequency-option-container");
    if (freqSelect.hasClass("active")) {
      freqSelect.removeClass("active");
    } else {
      freqSelect.addClass("active");
    }
  });

  $("body").on("click", ".custom-frequency-option", function () {
    //console.log($(this));
    $(".custom-frequency-option").removeClass("selected");
    $(".custom-frequency-option-container").removeClass("active");
    $(this).addClass("selected");

    let newText = $(this).attr("data-frequency-text");
    let newId = $(this).attr("data-selling-plan");
    $('input[name="subscription_frequency"]').val(newText);
    $('input[name="selling_plan"]').val(newId);
    $(".custom-frequency-selected span").text(newText);
  });

  $(".custom-otp").on("click", function () {
    $('input[name="selling_plan"]').attr(
      "data-value",
      $('input[name="selling_plan"]').val()
    );
    $('input[name="subscription_frequency"]').attr(
      "data-value",
      $('input[name="subscription_frequency"]').val()
    );

    setTimeout(function () {
      $('input[name="selling_plan"]').val("");
      $('input[name="subscription_frequency"]').val("");
    }, 0);
  });

  $(".custom-subsave").on("click", function () {
    $('input[name="selling_plan"]').val(
      $('input[name="selling_plan"]').attr("data-value")
    );
    $('input[name="subscription_frequency"]').val(
      $('input[name="subscription_frequency"]').attr("data-value")
    );

    setTimeout(function () {
      $('input[name="selling_plan"]').attr(
        "data-value",
        $('input[name="selling_plan"]').val()
      );
      $('input[name="subscription_frequency"]').attr(
        "data-value",
        $('input[name="subscription_frequency"]').val()
      );
    }, 0);
  });
}

function waitForElement(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

waitForElement(".rc_widget").then((el) => {
  $(".custom-widget-container").addClass("active");
  $(".custom-recharge-widget").addClass("active");
  initializeWidget();
});

// var loadWidget = setInterval(isLoaded, 500);

$(".custom-checkbox-container").on("click", function () {
  let checkboxContainer = $(this).parent();
  if (!checkboxContainer.hasClass("active")) {
    $(".custom-option-container").removeClass("active");
    checkboxContainer.addClass("active");
  }
});

$(".details-a").on("click", function () {
  $(".custom-rc-popup").addClass("active");
});
$(".custom-widget-overlay").on("click", function () {
  $(".custom-rc-popup").removeClass("active");
});
$(".custom-rc-popup .icon-close").on("click", function () {
  $(".custom-rc-popup").removeClass("active");
});

/**********
END WIDGET CODE
**********/

// RECURRING LOGIN PAGE CUSTOM CONTENT
const isRecurringLoginPage = window.location.href.includes(
  "tools/recurring/login"
);

if (isRecurringLoginPage) {
  $("#not_verified .rc_title-bar").each(function () {
    const $current = $(this);
    let content = rcTranslations?.get_login_link;

    if ($current.hasClass("rc_header-settings")) {
      content = rcTranslations?.login;
    }

    const $h4 = $current.find("h4");
    $h4.text(content?.title);
    $h4.next().text(content?.subtitle);
    $current.find("a").text(content?.link_text);
  });
}

$(".rc_layout").css("opacity", 1);
// END RECURRING LOGIN PAGE CUSTOM CONTENT

// making customily's monogram text uppercased
// try {
//   window.addEventListener("customily-options-loaded", function () {
//     console.log("rimmmmmmmmmmmm--->");
//     const monogramTextInputs = document.querySelectorAll(
//       '[name="properties[Monogram Text]"]'
//     );
//     console.log("monogramTextInputs--->",monogramTextInputs);
//     for (const monogramTextInput of monogramTextInputs) {
//       monogramTextInput.addEventListener("input", (e) => {
//         console.log("rim--->",monogramTextInput.value);
//         monogramTextInput.value = monogramTextInput.value.toUpperCase();
//       });
//     }
//   });
// } catch (ex) {
//   console.error(ex);
// }
window.addEventListener("customily-options-loaded", function () {
  const observer = new MutationObserver(() => {
    const monogramTextInputs = document.querySelectorAll('[name="properties[Monogram Text]"]');
    const selectFontInput = document.querySelector('[name="properties[Select Font]"]');

    // Attach input listener to Monogram field once it's present
    monogramTextInputs.forEach((input) => {
      if (!input.hasAttribute("data-listener-added")) {
        input.setAttribute("data-listener-added", "true");
        input.addEventListener("input", () => {
          input.value = input.value.toUpperCase();
        });
      }
    });

    // Optional: log select input for debug
    if (selectFontInput && !selectFontInput.hasAttribute("data-debugged")) {
      selectFontInput.setAttribute("data-debugged", "true");
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});





$(".img_link_hero_section").hover(function () {
  $("body").toggleClass("box-hover");
});

/*	
    updateDiscountTable()	
    on(variantChange, updateDiscountTable)	
    updateDiscountTable - validates if hulkapps-table2 element exists, loop through all <td> elements and write the result of (variant.price * (1 - parseInt(td:2) / 100)) to td:3	


  */
// PDP C&V Logic
function updateDiscountTable(curVariant) {
  const $table = $(".hulkapps-table");
  window.discountData = {
    singlePrice: curVariant.price,
    quantityDiscountMap: {
      1: 0,
    },
  };
  $table.each(function () {
    const $rows = $(this).find("tbody tr");
    $rows.each(function () {
      const $cells = $(this).find(
        "td:nth-child(1),td:nth-child(2),td:nth-child(3)"
      );
      const quantity = parseInt($($cells[0]).html());
      const discount = parseInt($($cells[1]).html()) / 100;
      const price = curVariant.price - curVariant.price * discount;
      $($cells[2]).html(Shopify.formatMoney(price));

      window.discountData.quantityDiscountMap[quantity] = discount;
    });
  });

  setTimeout(() => {
    updateDiscountQuantityPrice();
  }, 300);
}
function updateDiscountQuantityPrice() {
  if (!window.discountData) return;

  const { singlePrice, quantityDiscountMap } = window.discountData;

  const quantityVal = +$("#Quantity").val();
  if (!quantityVal) return;

  const thresholdQuantity = Object.keys(quantityDiscountMap)
    .reverse()
    .find((q, index, quantities) => {
      const prevThreshold = quantities[index + 1]
        ? quantities[index + 1]
        : quantities[index];
      return quantityVal >= +q && quantityVal >= +prevThreshold;
    });
  const discount = quantityDiscountMap[thresholdQuantity];
  const discountedPrice = singlePrice - singlePrice * discount;
  const originalPrice = singlePrice;
  const originalPriceHtml = `<s>${Shopify.formatMoney(originalPrice)} ${
    Shopify.currency.active
  }</s>`;
  $("[data-product-price]").html(`	
     ${discountedPrice !== originalPrice ? originalPriceHtml : ""}	
     ${Shopify.formatMoney(discountedPrice)} ${Shopify.currency.active}`);
  // const discountedPrice = (singlePrice - (singlePrice * discount)) * quantityVal
  // const originalPrice = singlePrice * quantityVal

  // const originalPriceHtml = `<s>${Shopify.formatMoney(originalPrice)} ${Shopify.currency.active}</s>`

  // $('[data-product-price]').html(`
  //   ${discountedPrice !== originalPrice ? originalPriceHtml : ''}
  //   ${Shopify.formatMoney(discountedPrice)} ${Shopify.currency.active}
  // `)
}
window.addEventListener("load", (event) => {
  setTimeout(() => {
    updateDiscountQuantityPrice();
  }, 300);
});
function freeShippingSlider(cart, country) {
  // if(country == "US" || country == "IN" || country == "\"IN,india\"")
  // {
  const items_array = cart.items;
  var is_subscrption_product = false;
  var final_line_price = 0;
  if (items_array.length !== 0) {
    for (let i = 0; i < items_array.length; i++) {
      var product_tag_value = items_array[i].properties._is_added_to_cart;
      // console.log("freeShippingSlider");
      // console.log(product_tag_value);
      if (items_array[i].properties.Frequency) {
        is_subscrption_product = true;
      }
      if (product_tag_value == "true") {
        final_line_price += items_array[i].final_line_price;
      }
    }
    if (is_subscrption_product) {
      document.getElementById("cart-progress").style.width = "100%";
      document.getElementById("free_shipping_price_text").innerHTML =
        "Hooray! Your order ships free.";
    } else {
      let progress_bar_per = 0;
      let free_shipping_price = $("#cart_progressbox").attr("data-limit");
      let free_shipping_price_o = free_shipping_price / 100;
      let items_subtotal_price = cart.items_subtotal_price - final_line_price;

      if (items_subtotal_price == 0) {
        document.getElementById("cart-progress").style.width = "0%";
        document.getElementById("free_shipping_price_text").innerHTML =
          "$" + free_shipping_price_o + " away from free shipping.";
      } else if (
        items_subtotal_price > 0 &&
        items_subtotal_price < free_shipping_price
      ) {
        progress_bar_per = items_subtotal_price / free_shipping_price_o;
        document.getElementById("cart-progress").style.width =
          progress_bar_per + `%`;
        var away_price = (free_shipping_price - items_subtotal_price) / 100;
        document.getElementById("free_shipping_price_text").innerHTML =
          "$" + away_price + " away from free shipping.";
      } else {
        document.getElementById("cart-progress").style.width = "100%";
        document.getElementById("free_shipping_price_text").innerHTML =
          "Hooray! Your order ships free.";
      }
    }
  }
  // }
  // else{
  // 	$(".progress_cart").hide();
  // }
}

function setBadgePos() {
  $(".badge-acf__box").each(function () {
    let bottomDiv = $(this).siblings(".featured-product__frame");
    let bottomDivHeight = bottomDiv.outerHeight();
    $(this).css({
      bottom: bottomDivHeight + "px",
    });
  });
}
setBadgePos();
$(window).resize(function () {
  setTimeout(() => {
    setBadgePos();
  }, 500);
});

$(".reviews-wrapper").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  autoplay: true,
  autoplaySpeed: 5000,
});

$(".inner-slider-div").owlCarousel({
  loop: false,
  margin: 0,
  dots: false,
  nav: false,
  items: 1,
});

window.logtest = (str, ...x) => {
  const logStyle =
    "font-size: 14px; color: white; background: #7258e0; padding: 2px;";
  if (typeof str === "object") {
    console.log(str, ...x);
  } else {
    console.log("%c" + str, logStyle, ...x);
  }
};

window._filterAllMedia = (variant, from) => {
  const productGallery = $(".js-product__gallery");
  const thumbnailGallery = $(".js-product__thumbnail-gallery");
  const productGallerySlickCheck = productGallery.hasClass("slick-initialized");
  const thumbGallerySlickCheck = thumbnailGallery.hasClass("slick-initialized");
  if (!productGallerySlickCheck) return false;

  function addTransformClass() {
    if (thumbGallerySlickCheck) {
      const thumbslider = thumbnailGallery.slick("getSlick");
      const slideCount = thumbslider.slideCount;
      if (slideCount < 6) {
        $(".slick-track", thumbnailGallery).addClass("transform-none");
      }
    }
  }

  if (window.product_data.variants.length === 1) {
    setTimeout(() => {
      addTransformClass();
    }, 500);
  }

  productGallery.slick("slickUnfilter");
  if (thumbGallerySlickCheck) {
    thumbnailGallery.slick("slickUnfilter");
  }

  const allImages = $("[data-product-slide],[data-product-single-thumbnail]");
  allImages.removeClass("is-filtered");
  allImages.each(function () {
    let image = $(this);
    const filterStr = image.attr("data-filter").split("||");
    const isMatched = variant.options.includes(
      filterStr[filterStr.length - 1].trim()
    );
    image.removeClass("is-filtered");
    if (isMatched) return;
    if (filterStr.length === 1) return;
    image.addClass("is-filtered");
    // if (image.data("variant-image") && image.data("variant-image") != variant.featured_image.id) {
    //   image.addClass("is-filtered");
    // }
  });

  productGallery.slick("slickFilter", ":not(.is-filtered)").slick("refresh");
  if (thumbGallerySlickCheck) {
    thumbnailGallery
      .slick("slickFilter", ":not(.is-filtered)")
      .slick("refresh");
  }

  setTimeout(() => {
    productGallery.slick("refresh");
    if (thumbGallerySlickCheck) {
      thumbnailGallery.slick("refresh");
    }
  }, 250);

  setTimeout(() => {
    const variantImgMain = $(
      `.product__gallery-item[data-variant-image="${variant.featured_image.id}"]`
    );
    const varIndexMain = variantImgMain.data("slick-index");
    addTransformClass();
    productGallery.slick("slickGoTo", varIndexMain);
    if (thumbGallerySlickCheck) {
      thumbnailGallery.slick("slickGoTo", varIndexMain);
    } else {
      $("[data-product-single-thumbnail]").removeClass("active-slide");
      $(
        `[data-variant-image="${variant.featured_image.id}"]`,
        thumbnailGallery
      ).addClass("active-slide");
    }
  }, 500);
};

window.isInViewport = (element) => {
  if (typeof jQuery === "function" && element instanceof jQuery) {
    element = element[0];
  }
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

